import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useDashboard } from '../contexts/DashboardContext';
import { apiFetch } from '../utils/api';

function ProbBar({ probability }) {
  if (probability == null) return <span className="text-muted small">—</span>;

  const pct = Math.round(probability * 100);

  return (
    <div className="d-flex align-items-center gap-1">
      <div className="flex-grow-1 rounded" style={{ height: '12px', backgroundColor: '#e9ecef' }}>
        <div
          className="rounded"
          style={{
            width: `${pct}%`,
            height: '100%',
            backgroundColor: 'rgba(13, 110, 253, 0.7)',
          }}
        />
      </div>
      <span className="text-end" style={{ width: '36px', fontSize: '0.75em' }}>
        {pct}%
      </span>
    </div>
  );
}

export default function MarketOverviewCard() {
  const { token } = useAuth();
  const { selectedTeam, selectedDate } = useDashboard();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token || !selectedTeam || !selectedDate) return;

    let cancelled = false;
    setLoading(true);
    setError(null);

    apiFetch(`/market-overview?team=${encodeURIComponent(selectedTeam)}&date=${selectedDate}`, token)
      .then((data) => {
        if (cancelled) return;
        setRows(data.rows);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message);
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, [token, selectedTeam, selectedDate]);

  return (
    <div className="card h-100">
      <div className="card-header d-flex align-items-center">
        <strong>Market Overview</strong>
        <span className="ms-auto text-muted small">All outrights</span>
      </div>
      <div className="card-body p-0">
        {loading && (
          <div className="text-center py-4"><div className="spinner-border spinner-border-sm" /></div>
        )}
        {error && (
          <div className="text-center py-4 text-danger small">{error}</div>
        )}
        {!loading && !error && rows.length === 0 && (
          <div className="text-center py-4 text-muted small">No data available</div>
        )}
        {!loading && !error && rows.length > 0 && (
          <div className="table-responsive">
            <table className="table table-sm mb-0 small">
              <thead>
                <tr>
                  <th className="ps-3">Market</th>
                  <th>Probability</th>
                </tr>
              </thead>
              <tbody>
                {rows.filter((row) => row.probability != null && row.probability >= 0.01).map((row) => (
                  <tr key={row.market}>
                    <td className="ps-3 text-nowrap" style={{ width: '100px' }}>{row.label}</td>
                    <td><ProbBar probability={row.probability} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
